import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, from, of, switchMap, throwError } from 'rxjs';
import { DialogService } from '../services/dialog.service';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';

const DEFAULT_ERROR_MESSAGE = 'Si è verificato un errore.';
const RETRY_HINT = ' Riprova tra qualche istante.';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
	const dialogService = inject(DialogService);
	const authService = inject(AuthService);

	// body: corpo dell'errore già come oggetto (per le risposte blob va letto prima)
	const handleError = (
		error: HttpErrorResponse,
		body: any,
		isBlob: boolean
	): string => {
		let errorMessage = '';
		console.error(error);
		if (error.status === 401) {
			errorMessage = body?.exception?.errorMessage ?? DEFAULT_ERROR_MESSAGE;
			console.error('Errore intercettato:', error.status);
			dialogService.openDialogError('Errore', errorMessage);
			authService.logout();
		} else if (error.status === 500) {
			errorMessage = body?.exception?.errorMessage ?? DEFAULT_ERROR_MESSAGE;
			if (isBlob) errorMessage += RETRY_HINT;
			console.error('Errore intercettato:', error.status);
			dialogService.openDialogError('Errore', errorMessage);
		} else if (body?.exception) {
			errorMessage = body.exception.errorMessage;
			console.error('Errore intercettato:', error.status);
			dialogService.openDialogError('Errore', errorMessage);
		}
		return errorMessage;
	};

	return next(req).pipe(
		catchError((error: HttpErrorResponse) => {
			// Con responseType 'blob' anche il corpo dell'errore è un Blob
			if (error.error instanceof Blob) {
				return from(error.error.text()).pipe(
					switchMap(text => {
						try {
							return of(JSON.parse(text));
						} catch {
							return of(null);
						}
					}),
					switchMap(body =>
						throwError(() => handleError(error, body, true))
					)
				);
			}

			throw handleError(error, error.error, false);
		})
	);
};
